/** Who is signed in, independent of how: Kinde in production, a fixed admin in mock mode. */
import { createContext, useContext } from 'react'

export interface Session {
  isLoading: boolean
  isAuthenticated: boolean
  email: string | null
  name: string | null
  /** The access token for the API audience. */
  getToken: () => Promise<string | undefined>
  login: () => void
  /** Kinde's sign-up (prompt=create): cpg.computer's /signup hands off here with ?signup=1. */
  register: () => void
  logout: () => void
  /** Kinde's own error, e.g. a callback that failed. */
  error?: string
  mock?: boolean
}

export const SessionContext = createContext<Session | null>(null)

export function useSession(): Session {
  const s = useContext(SessionContext)
  if (!s) throw new Error('useSession outside a session provider')
  return s
}
